import { NgModule } from '@angular/core';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../../_guards/auth.guard';
import { AddToBlackPhotoComponent } from './addtoblackphoto.component';
import { DialogComponent } from './dialog/dialog.component';
import { RoleGuard } from '../../../_guards/role.guard';


const routes: Routes = [
  {
      path     : 'addtoblackphoto',
      component: AddToBlackPhotoComponent,
      data :{
        permission:{
            only :['role1' ,'role2']
        }
    },
      canActivate:[AuthGuard,RoleGuard]
  }
];

@NgModule({
  imports: [
    SharedModule,
    RouterModule.forChild(routes)
  ],
  declarations: [
   AddToBlackPhotoComponent,
   DialogComponent
  ],
  entryComponents:[DialogComponent],
  providers:[
      AuthGuard,RoleGuard
  ]
})
export class AddToBlackPhotoModule { }



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/addtoblackphoto/addtoblackphoto.module.ts